import React, { Component } from "react";
import PropTypes from "prop-types";
import ContentPageActionsContent from "./ContentPageActionsContent";
import DataContainer from "components/utility/data-container/DataContainer";

class ContentPageActions extends Component {
	render() {
		const { guid = "1234" } = this.props.dataset;
		// let guid = 0;
		return (
			<DataContainer data={"contentPageActionsData_" + guid}>
				<ContentPageActionsContent dataset={this.props.dataset} />
			</DataContainer>
		);
	}
}

ContentPageActions.propTypes = {
	dataset: PropTypes.shape({
		hideShare: PropTypes.string.isRequired,
		hideFavorite: PropTypes.string.isRequired,
		hideDownload: PropTypes.string.isRequired,
		downloadUrl: PropTypes.string,
		color: PropTypes.oneOf(["teal", "default", "yellow"]),
		isModule: PropTypes.string,
		isContentPageTop: PropTypes.string,
		isHeaderCollapsed: PropTypes.string
	}).isRequired
};

export default ContentPageActions;
